import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

/**
 * Native-only startup chrome setup (Android/iOS via Capacitor).
 *
 * Android targets SDK 35 (variables.gradle), which enforces edge-to-edge
 * (WebView drawing behind the status bar / gesture nav bar) on Android 15+
 * regardless of app config — that's the direct cause of the status bar
 * overlapping the header before this fix. Explicitly requesting the same
 * edge-to-edge layout here makes the behavior IDENTICAL on every supported
 * Android version (12-14 does not force it on its own), so the CSS
 * env(safe-area-inset-*) handling added across TopNav/Sidebar/Drawer/Footer
 * (see designTokens.ts safeAreaTop/safeAreaBottom) sees the same real inset
 * values everywhere instead of only on Android 15+ devices.
 *
 * setStyle('Dark') = light (white) status bar icons/text, correct for this
 * app's permanently dark background — without it, some Android versions
 * default to dark icons that are unreadable on our theme.
 *
 * No-ops safely on web (isNativePlatform() false) and degrades quietly if
 * the plugin call fails on iOS/Android specifics we haven't hit yet.
 */
export function initNativeChrome(): void {
  if (!Capacitor.isNativePlatform()) return;

  void StatusBar.setOverlaysWebView({ overlay: true }).catch(() => {});
  void StatusBar.setStyle({ style: Style.Dark }).catch(() => {});
}
